import { defineStore } from 'pinia'
import axios from 'axios'

const API_URL = (import.meta.env.VITE_API_URL || 'https://it-ticketing-api.maulanarofiq72.workers.dev').replace(/\/$/, '')
console.log('Auth Store: Initializing with API_URL =', API_URL)
if (!import.meta.env.VITE_API_URL) {
  console.warn('Auth Store: VITE_API_URL is NOT defined in environment variables, falling back to localhost.')
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
    adminNotifications: 0
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
  },
  actions: {
    async fetchNotifications() {
      if (this.user && (this.user as any).role === 'ADMIN') {
        try {
          const response = await axios.get(`${API_URL}/admin/requests`)
          this.adminNotifications = response.data.access.length + response.data.resets.length
        } catch (e) { /* silent */ }
      }
    },
    async login(username: string, password: string) {
      const formData = new FormData()
      formData.append('username', username)
      formData.append('password', password)
      
      const response = await axios.post(`${API_URL}/token`, formData)
      this.token = response.data.access_token
      if (this.token) {
        localStorage.setItem('token', this.token)
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        await this.fetchUser()
      }
    },
    async fetchUser() {
      if (!this.token) return
      try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        const response = await axios.get(`${API_URL}/users/me`)
        this.user = response.data
        localStorage.setItem('user', JSON.stringify(this.user))
      } catch (error) {
        console.error('Failed to fetch user, logging out', error)
        this.logout()
      }
    },
    initialize() {
      if (this.token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
        const savedUser = localStorage.getItem('user')
        if (savedUser) {
          this.user = JSON.parse(savedUser)
        }
        this.fetchUser()
      }
    },
    logout() {
      this.user = null
      this.token = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']
    }
  }
})
